module.exports = __webpack_public_path__ + "img/330ca25.jpg";